export const SEARCH_PROVIDER_INIT_SEARCH = '@@searchProvider/initSearch';
export const SEARCH_PROVIDER_TRIGGER_INIT = '@@searchProvider/initSearch';
